import { withValidate } from "./withValidate";
import { ThemedButton } from "./Button";
import { twMerge } from "tailwind-merge";
import { MouseEvent } from "react";

export interface ControllerSelectOption {
  value: string;
  label: string | React.ReactNode;
  disabled?: boolean;
}

export interface ControllerSelectProps {
  max?: number;
  options: ControllerSelectOption[];
  col?: number;
  value?: string[]; // Controller에서 전달되는 값
  onChange?: (value: string[]) => void; // Controller에서 전달되는 onChange
  className?: string;
  ThemedClassName?: string;
  textClassName?: string;
}

export const ControllerSelect = ({
  value = [],
  max,
  onChange,
  options,
  col = 3,
  className,
  ThemedClassName,
  textClassName = "",
}: ControllerSelectProps) => {
  const handleChange = (e: MouseEvent) => {
    const target = e.target;
    if (target instanceof HTMLElement) {
      const clickedValue = target.dataset.value;
      if (!clickedValue) return;

      // disabled된 옵션인지 확인
      const clickedOption = options.find(
        (option) => option.value === clickedValue
      );
      if (clickedOption?.disabled) {
        return; // disabled된 옵션은 클릭해도 아무 동작 안함
      }

      let newValues = [...value];

      if (max === 0) {
        return;
      }

      if (value.includes(clickedValue)) {
        // 이미 선택된 값이면 제거
        newValues = value.filter((v) => v !== clickedValue);
      } else {
        // 새로운 값 추가
        if (max && value.length >= max) {
          // 최대값 초과 시 첫 번째 값 제거
          newValues.shift();
        }
        newValues.push(clickedValue);
      }

      onChange?.(newValues);
    }
  };
  console.log(value);
  return (
    <div
      className={twMerge("grid gap-2", className)}
      style={{
        gridTemplateColumns: `repeat(${col}, minmax(0, 1fr))`,
      }}
    >
      {options?.map((option) => (
        <ThemedButton
          data-value={option.value}
          onClick={handleChange}
          className={twMerge(
            !value?.includes(option.value) && "border-[#999] text-[#999999]",
            option.disabled && "opacity-50 cursor-not-allowed bg-gray-100",
            ThemedClassName,
            textClassName
          )}
          color="secondary"
          type="button"
          key={option.value}
        >
          {option.label}
        </ThemedButton>
      ))}
    </div>
  );
};

export const ValidateControllerSelect = withValidate(ControllerSelect);
